<template>
  <div class="ts-space-y-2">
    <div class="row">
      <div class="col-md-12">
        <label class="ts-text-xs" >{{ $t('department.nameKh') }}</label>
        <input
          v-model="model.department_name_kh"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('department_name_kh') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('department_name_kh')"
        >{{ errors.first('department_name_kh') }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-text-xs">{{ $t('department.nameEn') }}</label>
        <input
          v-model="model.department_name_en"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('department_name_en') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('department_name_en')"
        >{{ errors.first('department_name_en') }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 ts-mt-3 text-right">
        <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
          {{
          $t('cancel')
          }}
        </ts-button>
        <ts-button
          v-if="!isUpdate"
          color="primary"
          @click.prevent="onSave"
          :waiting="waiting"
        >{{ $t('save') }}</ts-button>
        <ts-button
          v-if="isUpdate"
          color="primary"
          @click.prevent="onUpdate"
          :waiting="waiting"
        >{{ $t('update') }}</ts-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'companyForm',
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      waiting_new: false,
      model: {
        department_id: 0,
        department_name_kh: null,
        department_name_en: null
      }
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('employee/department', ['edit_data']),
    isUpdate() {
      return !_.isEmpty(this.edit_data)
    }
  },
  methods: {
    onSave() {
      this.waiting = true
      this.$store
        .dispatch('employee/department/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.$store
        .dispatch('employee/department/update', {
          id: this.model.department_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.department_id = this.edit_data.department_id
        this.model.department_name_kh = this.edit_data.department_name_kh
        this.model.department_name_en = this.edit_data.department_name_en
      }
    }
  }
}
</script>
